export enum CodeCategoryViewMode {
  PERCENTAGE = 'PERCENTAGE',
  COUNT = 'COUNT',
  NONE = 'NONE',
}

export type CreateCodeCategory = {
  name: string;
  color: string;
  showInHeaderAs: CodeCategoryViewMode;
  showInReport: boolean;
};

export type CodeCategory  = CreateCodeCategory & {
  id: string;
};
